import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PredefinedValue } from '../../../../../interfaces/predefined-value.interface';
import { ReferenceField } from '../../../../../interfaces/reference-field.interface';
import { DictionaryItem } from '../../../../../interfaces/dictionary-item.interface';
import { DataSourceOption } from '../../data-source-options';

@Component({
  selector: 'forms-data-source-field-option',
  templateUrl: './data-source-field-option.component.html',
  })
export class DataSourceFieldOptionComponent implements OnChanges {
  @Input() option!: DataSourceOption;
  @Input() dataSource!: 'dictionary' | 'dataView' | 'predefined';

  protected displayOption: string;

  constructor() {}

  ngOnChanges(): void {
    this.prepareDisplayValue();
  }

  shouldDisplaySubtitle() {
    return this.dataSource === 'dataView' && ((this.option as ReferenceField).rowFormat && (this.option as ReferenceField).rowFormat.subtitle)
  }

  private prepareDisplayValue(): void {
    this.displayOption = DataSourceFieldOptionComponent.getValueFromOption(this.dataSource, this.option);
  }

  public static getValueFromOption(dataSourceType: string, option: DataSourceOption) {
    if (typeof option === 'string') {
      return option;
    }

    switch (dataSourceType) {
      case 'dictionary':
        return (option as DictionaryItem).name;
      case 'dataView':
        if ((option as ReferenceField).rowFormat && (option as ReferenceField).rowFormat.title) {
          return (option as ReferenceField).rowFormat.title;
        }
        return (option as ReferenceField).dataViewColumn;
      case 'predefined':
        return (option as PredefinedValue).value;
    }
  }

  protected prepareDisplaySubtitleValue(): string {
    if (this.dataSource !== 'dataView') {
      return ;
    }
    return (this.option as ReferenceField).rowFormat.subtitle;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/data-source/data-source/data-source-field-option/data-source-field-option.component.ts